import { LogIn, UserCircle2 } from 'lucide-react'
import { useCommunity } from './CommunityProvider'

export function AccountButton() {
  const { user, authLoading, openAccount } = useCommunity()
  return <button className="community-account" onClick={openAccount} aria-label={user ? `Open profile for ${user.displayName ?? 'your account'}` : 'Sign in to OMIKINA'} disabled={authLoading}>
    {user?.photoURL ? <img src={user.photoURL} alt="" referrerPolicy="no-referrer"/> : user ? <UserCircle2/> : <LogIn/>}
    <span>{authLoading ? 'ACCOUNT' : user ? (user.displayName?.split(' ')[0] ?? 'PROFILE').toUpperCase() : 'SIGN IN'}</span>
  </button>
}
